import { useEffect, useMemo, useState, useRef } from 'react';

import type { Notification } from 'entities/notification';

import { isNotificationRead } from '../lib/is-notification-read';
import { isNotificationUrgent } from '../lib/is-notification-urgent';

export const useUrgentNotification = (notifications: Notification[]) => {
  const prevNotificationsRef = useRef<Notification[]>([]);

  const [urgentNotification, setUrgentNotification] = useState<Notification | null>(null);

  useEffect(() => {
    const prevNotifications = prevNotificationsRef.current;

    let urgentNotification: Notification | null = null;

    if (prevNotifications.length === 0) {
      prevNotificationsRef.current = notifications;
      setUrgentNotification(notifications.find(isNotificationUrgent) ?? null);
      return;
    }

    const prevNotificationIds = new Set(prevNotifications.map(n => n.id));

    for (const notification of notifications) {
      if (!isNotificationRead(notification) && !prevNotificationIds.has(notification.id)) {
        urgentNotification = notification;
        break;
      }
    }

    prevNotificationsRef.current = notifications;

    setUrgentNotification(urgentNotification);
  }, [notifications]);

  return { urgentNotification };
};
